// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,

  // baseUrl: "http://localhost:8000/",
  // appUrl: "http://localhost:4200/mongoose/dashboard/sprintboard",
  // loginUrl: "http://localhost:4200/preauth/login",
  // clientAppUrl: "http://localhost:4200/mongoose/works/projects",
  // imageUrl: "http://qa.int.crowderia.com/pm_api/public/api/files/profileimage/",

  // baseUrl: "http://qa.int.crowderia.com/pm_api/public/",
  // appUrl: "http://qa.pm.crowderia.com/mongoose/dashboard/sprintboard",
  // loginUrl: "http://qa.pm.crowderia.com/preauth/login",
  // imageUrl: "http://qa.int.crowderia.com/pm_api/public/api/files/profileimage/",
  // clientAppUrl: "http://qa.pm.crowderia.com/mongoose/works/projects"

  baseUrl: "https://int.crowderia.com/pm_api/public/",
  appUrl: "https://pm.crowderia.com/mongoose/dashboard/sprintboard",
  loginUrl: "https://pm.crowderia.com/preauth/login",
  imageUrl: "https://int.crowderia.com/pm_api/public/api/files/profileimage/",
  clientAppUrl: "https://pm.crowderia.com/mongoose/works/projects"

};
//   http://localhost:4200/preauth?t=WrkV%2BbYDZUb8LwMxscuvMTl8gHE7JLrbOGMN%2BVq1nkU%3D



// WEBPACK FOOTER //
// ./src/environments/environment.ts